import { useCallback } from 'react'

import { useSelector } from 'react-redux'
import { useSWRConfig } from 'swr'

import { getBasketDate, getNumPortions } from 'selectors/basket'

import type { MenuQueryParams } from '../../../context/menuQueryContext'
import { getMenuExperienceMenuSWRKey } from './useMenuExperienceNavigation'

type MenuExperienceRefreshQuery = MenuQueryParams &
  Record<string, unknown> & {
    collection?: string
  }

export const useMenuExperienceRefresh = (query: MenuExperienceRefreshQuery) => {
  const { mutate } = useSWRConfig()
  const deliveryDate = useSelector(getBasketDate)
  const numPortions = useSelector(getNumPortions)

  return useCallback(() => {
    const menuExperienceKey = getMenuExperienceMenuSWRKey({
      deliveryDate,
      numPortions,
      query,
    })

    return menuExperienceKey ? mutate(menuExperienceKey) : undefined
  }, [deliveryDate, mutate, numPortions, query])
}
